import {
  contract_status_options,
  contracts,
  create_contract_form,
  deliverable_rows,
  register_cards,
  renewal_rows,
  sla_cards,
  sla_rows,
  tabs
} from './contract_data';
import { contract_lifecycle_hooks, contract_methods, contract_watch } from './contract_helper';
import { contract_drawers, drawer_computed } from './contract_drawer';

export default {
  name: 'ComplyonContracts',
  data: () => ({
    tabs,
    active_tab: 'register',
    register_cards,
    contracts,
    renewal_rows,
    sla_cards,
    sla_rows,
    deliverable_rows,
    contract_drawers,
    contract_status_options,
    contract_modal_open: false,
    contract_form: create_contract_form(),
    active_contract_drawer_key: null
  }),
  computed: {
    ...drawer_computed
  },
  methods: {
    ...contract_methods
  },
  mounted: contract_lifecycle_hooks.mounted,
  beforeDestroy: contract_lifecycle_hooks.beforeDestroy,
  watch: contract_watch
};
